<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="contentt"></mobile-menu>
      <el-menu
        :default-active="routerPath"      
        class="el-menu-vertical-demo"
        background-color="#000"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
      >
        <el-menu-item index="/admin/MyMeeting"  >
          <i class="el-icon-s-opportunity"></i>
          <span slot="title">我的会议</span>
        </el-menu-item>
        <!-- <el-menu-item index="/admin/TheRegistrationManagement" >
          <i class="el-icon-s-custom"></i>
          <span slot="title">报名管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/TheOrderManagement" >
          <i class="el-icon-tickets"></i>
          <span slot="title">订单管理</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="/admin/Bmjigou">
          <i class="el-icon-office-building"></i>
          <span slot="title">部门会议管理</span>
        </el-menu-item> -->
        <!-- v-show="team" -->
          <el-menu-item index="/admin/Special" >
          <i class="el-icon-s-promotion"></i>
          <span slot="title">会议专题</span>
        </el-menu-item>
        <!-- <el-menu-item index>     
          <i class="menu-icon nc-icon nc-single-copy-04"></i>
          <span slot="title">发票管理</span>
        </el-menu-item> -->
      </el-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar">
        <router-view></router-view>
      </dashboard-content>
    </div>
  </div>
</template>
<script>
import TopNavbar from "../TopNavbar";
import ContentFooter from "../ContentFooter.vue";
import DashboardContent from "../Content.vue";
import MobileMenu from "../MobileMenu.vue";
export default {
  name: "dashboard-layot",
  data() {
    return {
      routerPath: "/admin/MyMeeting",
      dep_is_auth:"true",
      team:"true"
    };
  },
  created(){
    // if(localStorage.getItem("team_is_auth")=="false"){
    //   if(localStorage.getItem("dep_is_auth")=="false" ){
    //    this.team=false
    //    this.dep_is_auth=false
    // }else if(localStorage.getItem("dep_is_auth")=="true"){
    //     this.dep_is_auth=false
    //     this.team=true
    //     this.routerPath="/admin/Pishu"
    // }
    // }else{
    //    this.dep_is_auth=true
    //    this.team=true
    //   this.routerPath="/admin/MyMeeting"
    // }
   
     
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted(){
    let defaultMenu = window.location.hash.substr(
      window.location.hash.indexOf("/")
    );
    this.routerPath = defaultMenu;
  }
};
</script>
<style  scoped>
.el-menu {
  border: 0;
}
.menu-icon {
  margin-right: 10px;
  font-size: 20px;
  line-height: 56px;
}
.el-menu-item.is-active::after {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  z-index: 99;
  left: 0;
  top: 0;
}
</style>
